export const getStyles = (_components, { palette = {} } = {}) => ({
  codeSnippetContainer: {
    fontSize: '14px',
    lineHeight: '20px',
    color: palette.neutralPrimary,
    marginBottom: '12px',
    border: '1px solid black',
    padding: 20,
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    width: 500,

    '& mark': {
      background: 'inherit',
      color: palette.orange,
      padding: 0,
    },
  },
});
